import React from 'react';
import LetterSequence from './LetterSequence';
import ClassroomBalloonWord from './ClassroomBalloonWord';
const BURST_PARTICLES = Array.from({ length: 10 }, (_, index) => ({
  angle: `${index * 36}deg`,
  distance: `${66 + (index % 3) * 15}px`,
  color: ['#ffda55', '#fa699d', '#ae7cf8', '#7ddbe7', '#ffffff'][index % 5],
}));

export const PALETTE = [
  ['#ff77a5', '#ee427c'], ['#b383fc', '#844ee8'], ['#ffca60', '#ff9b27'],
  ['#61c2f8', '#358def'], ['#92df68', '#56bb62'], ['#ffae77', '#ed784b'],
];

export default function BalloonOption({ slot, disabled = false, locked = false, popping, shaking, onSelect, fitLabel = false, schoolLetters = false }) {
  const [light, dark] = PALETTE[slot.color];
  return <button type="button"
              aria-label={`${slot.word} yazan balon`}
              data-balloon-word={slot.word}
              disabled={disabled}
              aria-disabled={locked || undefined}
              onClick={() => { if (!locked) onSelect(); }}
              className={`balloon-pop-option ${popping ? 'is-popping' : ''} ${shaking ? 'is-shaking' : ''}`}
              style={{ '--balloon-light': light, '--balloon-dark': dark,
                ...(fitLabel ? { '--balloon-letters': slot.word.length } : {}) }}>
              <span className="balloon-pop-float">
                <span className="balloon-pop-shape" key={slot.nonce}>
                  <span className="balloon-pop-highlight" aria-hidden="true" />
                  <span className="balloon-pop-label" aria-hidden="true">{schoolLetters ? <ClassroomBalloonWord word={slot.word} /> : [...slot.word].every((letter) => ["a", "n", "e", "t", "i", "l"].includes(letter))
                    ? <LetterSequence value={slot.word} />
                    : <span className="balloon-pop-plain-word">{slot.word}</span>}</span>
                </span>
                <svg className="balloon-pop-knot" data-testid="balloon-tied-knot" viewBox="0 0 30 25" focusable="false" aria-hidden="true">
                  <path className="balloon-pop-knot-body"
                    d="M12 1 C10 5 11 7 7 11 C4 14 3 18 6 20 C9 23 13 19 15 19 C18 19 22 23 25 20 C28 17 25 13 21 10 C18 7 19 5 17 1 Z" />
                  <path className="balloon-pop-knot-light" d="M10 13 C12 10 17 10 20 13" />
                </svg>
                <svg className="balloon-pop-string" data-testid="balloon-curved-thread" viewBox="0 0 42 60" preserveAspectRatio="none"
                  focusable="false" aria-hidden="true">
                  <path className="balloon-pop-string-shadow"
                    d="M21 1 C16 13 26 20 20 33 C15 45 23 48 19 59" />
                  <path className="balloon-pop-string-thread"
                    d="M21 1 C16 13 26 20 20 33 C15 45 23 48 19 59" />
                </svg>
              </span>
              {popping && <span className="balloon-pop-burst" aria-hidden="true">
                <span className="balloon-pop-flash" />
                {BURST_PARTICLES.map((spark, sparkIndex) => <span key={sparkIndex}
                  className="balloon-pop-spark" data-testid="balloon-burst-particle" style={{
                    '--spark-angle': spark.angle,
                    '--spark-distance': spark.distance,
                    '--spark-color': spark.color,
                  }} />)}
              </span>}
            </button>;
}
